module.exports = __webpack_public_path__ + "img/bg_3.0cdc3b47.png";